var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1183 3.10889H17.3749C18.2812 3.10889 19.016 3.84365 19.016 4.75001V18.6995C19.016 19.6059 18.2812 20.3406 17.3749 20.3406H1.78424C0.877881 20.3406 0.143127 19.6059 0.143127 18.6995V4.75001C0.143127 3.84365 0.877881 3.10889 1.78424 3.10889H3.01508C3.24167 3.10889 3.42536 3.29258 3.42536 3.51917V5.36543C3.42536 5.70532 3.70089 5.98085 4.04078 5.98085C4.38067 5.98085 4.6562 5.70532 4.6562 5.36543V1.46778C4.6562 1.01459 5.02358 0.647217 5.47676 0.647217C5.92994 0.647217 6.29732 1.01459 6.29732 1.46778V2.90457C6.29777 3.01755 6.38948 3.10889 6.50246 3.10889H11.6309C11.8575 3.10889 12.0412 3.29258 12.0412 3.51917V5.36543C12.0412 5.70532 12.3168 5.98085 12.6566 5.98085C12.9965 5.98085 13.2721 5.70532 13.2721 5.36543V1.46778C13.2721 1.01459 13.6394 0.647217 14.0926 0.647217C14.5458 0.647217 14.9132 1.01459 14.9132 1.46778V2.90375C14.9132 3.01705 15.005 3.10889 15.1183 3.10889ZM2.19451 18.6996H16.9646C17.1912 18.6996 17.3748 18.5159 17.3748 18.2893V8.44259C17.3748 8.216 17.1912 8.03231 16.9646 8.03231H2.19451C1.96792 8.03231 1.78423 8.216 1.78423 8.44259V18.2893C1.78423 18.5159 1.96792 18.6996 2.19451 18.6996Z",
    fill: "#D19B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.cb237887a4033aa5d2dd51445097cce1.svg";
export { ForwardRef as ReactComponent };